module.exports = __webpack_public_path__ + "img/app-es.c7b8bb8c.gif";